import React, { useEffect, useRef } from 'react';
import { useIntersectionObserver } from 'usehooks-ts';
import { ScrollMenu, type publicApiType } from 'react-horizontal-scrolling-menu-7';
import { OnScreenContext } from './OnScreenContext';
import 'react-horizontal-scrolling-menu-7/dist/styles.css';
import LeftArrow from './Arrow/LeftArrow';
import RightArrow from './Arrow/RightArrow';

const onWheel = (apiObj: publicApiType, ev: React.WheelEvent) => {
  // NOTE: there is no good standard way to distinguish touchpad scrolling gestures,
  // but we can assume that gesture will affect X axis, mouse scroll only Y axis
  // or if deltaY too small it's probably touchpad
  const isTouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;

  if (isTouchpad) {
    ev.stopPropagation();
    return;
  }

  if (ev.deltaY < 0) {
    apiObj.scrollNext();
  } else {
    apiObj.scrollPrev();
  }
};

interface HorizontalScrollMenuProps {
  hideArrows: boolean;
  children: ReactChildren;
  selected?: string;
}

const HorizontalScrollMenu = ({ hideArrows = false, children, selected }: HorizontalScrollMenuProps) => {
  // NOTE: to show/hide arrows only when main component is on screen and visible
  const { isIntersecting: isVisible, ref } = useIntersectionObserver({ threshold: 1 });
  const scrollMenuRef = useRef(null);

  useEffect(() => {
    if (selected && scrollMenuRef.current) {
      const item = scrollMenuRef.current.getItemById(selected);
      scrollMenuRef.current.scrollToItem(item, 'smooth', 'start');
    }
  }, [selected]);

  return (
    <div ref={ref}>
      <OnScreenContext.Provider value={isVisible}>
        <ScrollMenu
          apiRef={scrollMenuRef}
          LeftArrow={<LeftArrow isDisabled={hideArrows} />}
          RightArrow={<RightArrow isDisabled={hideArrows} />}
          scrollContainerClassName="no-scrollbar tw-pt-1"
          onWheel={onWheel}
        >
          {/* @ts-ignore */}
          {children}
        </ScrollMenu>
      </OnScreenContext.Provider>
    </div>
  );
};

export default HorizontalScrollMenu;
